import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class IframeService {
  constructor() {}
  private _property$: BehaviorSubject<boolean> = new BehaviorSubject(null);

  /**
   * Devuelve un observable con el valor de la propiedad.
   * @returns Observable con el valor de la propiedad.
   */
  public getInIframe(): Observable<boolean> {
    return this._property$.asObservable();
  }
  /**
   * Establece el valor de la propiedad.
   * @param {boolean} value - El valor de la propiedad.
   */
  public setInIframe(value: boolean) {
    this._property$.next(value);
  }
}
